module.exports = __webpack_public_path__ + "img/4.34a55c59.jpg";